module.exports = __webpack_public_path__ + "static/media/sharecard-slide-sale2.b8e0c291.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sharecard-slide-sale2.png
// module id = 2063
// module chunks = 6